module.exports = __webpack_public_path__ + "img/appicon.0c76c7aa.png";